import React from 'react';
import connect from 'Shared/connect';
import { getSelectedVariant } from 'Shared/Product/reducer';
import { getCartLineItemsForVariants } from '../../Cart/reducer';
import { selectVariant, toggleSelectedVariant } from 'Shared/Product/action-creators';
import * as styles from './base.scss';
import Button from 'Shared/Button';
import classnames from 'classnames';
const VariantSelection = ({ variants, selectedUnitShortName, onSelectVariant }) => (React.createElement(React.Fragment, null, variants.length > 1 ? (variants.map(v => (React.createElement(Button, { key: v.code, appearance: "bare", onClick: () => onSelectVariant(v.unitShortName), className: classnames(styles.button, { [styles.selected]: v.unitShortName === selectedUnitShortName }) }, v.unitShortName)))) : (React.createElement("div", { className: styles.placeholderText },
    " ",
    variants[0].unitShortName))));
export { VariantSelection };
class VariantSelectionContainer extends React.Component {
    constructor() {
        super(...arguments);
        this.setSelectedVariant = (unitShortName) => {
            const variant = this.getVariantFromUnitShortName(unitShortName);
            if (variant) {
                this.props.selectVariant(variant.code, this.props.product.variants);
                if (this.props.onSelectVariant)
                    this.props.onSelectVariant(this.props.product.selectedVariant.code, variant.code);
            }
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.cartLineItems.length === 1 && this.props.cartLineItems.length === 2) {
            this.props.selectVariant(newProps.cartLineItems[0].code, this.props.product.variants);
        }
    }
    getVariantFromUnitShortName(unitShortName) {
        return this.props.product.variants.find(v => v.unitShortName === unitShortName);
    }
    getSelectableVariants() {
        if (this.props.preferedVariant && this.props.cartLineItems.length > 1) {
            return [this.props.preferedVariant];
        }
        if (this.props.product.isWeightProduct) {
            return this.props.product.variants.filter(v => v.unitShortName === this.props.unitShortName);
        }
        return this.props.product.variants;
    }
    render() {
        const { Component, unitShortName } = this.props;
        return (React.createElement(Component, { onSelectVariant: this.setSelectedVariant, selectedUnitShortName: unitShortName, variants: this.getSelectableVariants() }));
    }
}
VariantSelectionContainer.defaultProps = {
    Component: VariantSelection,
};
export default connect((state, ownProps) => ({
    selectedVariant: getSelectedVariant(state, ownProps.product.variants),
    cartLineItems: getCartLineItemsForVariants(state, ownProps.product.variants),
}), (dispatch, ownProps) => ({
    selectVariant: (variantCode) => dispatch(selectVariant(variantCode, ownProps.product.variants)),
    toggleSelectedVariant: (currentSelectedVariantCode) => dispatch(toggleSelectedVariant(currentSelectedVariantCode, ownProps.product.variants)),
}))(VariantSelectionContainer);
